import React from 'react';

const TextArea = (props) => <textarea {...props} />;

export default TextArea;
